import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ServersAssignmentService } from 'src/app/features/Floors-and-Kitchens/servers-assignment/services/servers-assignment.service';
import Swal from 'sweetalert2';
import { ReservationDetails, Waiter } from '../../../models/Reservation';

export interface DialogData {
  reservation: ReservationDetails,
  restaurantId: number,
  reservationId: number
}
@Component({
  selector: 'app-reassign-server',
  templateUrl: './reassign-server.component.html'
})
export class ReassignServerComponent implements OnInit {
  dataLoading = false;
  loading = false;
  isSubmitted = false;

  categoryList: any[] = [];
  categorySelected?: any;
  searchText?: any;

  serversList: Waiter[] = [];
  userId: any

  constructor(
    private service: ServersAssignmentService,
    private dialogRef: MatDialogRef<ReassignServerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    if (this.data.reservation.waitersList.length === 1) {
      this.userId = this.data.reservation.waitersList[0].id;
    }
    this.getServers();
  }

  getServers() {
    this.dataLoading = true;
    this.service.ResWaitersList(this.data.restaurantId).subscribe(
      (data: any) => {
        this.dataLoading = false;
        if (data) {
          this.serversList = data;
        }
      },
      (error: any) => {
        this.serversList = [];
      });
  }

  hideOption(item: any) {
    return new RegExp(this.searchText, 'i').test(item.name) === false
  }
  isAllHidden() {
    return this.serversList.every(item => this.hideOption(item));
  }

  saveRecord() {
    this.isSubmitted = true;
    if (!this.userId) return;

    this.loading = true;
    let data = {
      reservationId: this.data.reservationId,
      userId: this.userId
    }
    this.service.ResEditReservationWaiter(data).subscribe((response: any) => {
      this.loading = false;
      if (response?.success) {
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }
    }, error => {
      this.loading = false;
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    });
  }
}
